import { useEffect, useState } from 'react'
import styles from './SplashScreen.module.css'

interface SplashScreenProps {
  duration?: number
  onComplete: () => void
}

export function SplashScreen({ duration = 6000, onComplete }: SplashScreenProps) {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
      onComplete()
    }, duration)

    return () => clearTimeout(timer)
  }, [duration, onComplete])

  if (!isVisible) return null

  return (
    <div className={styles.splashContainer}>
      {/* OneDrive Loading Icon - Center */}
      <img
        src="https://res.public.onecdn.static.microsoft/owamail/hashed-v1/resources/images/onedrive_24x-hash-e0d279de.m.svg"
        alt="Loading"
        className={styles.loadingIcon}
      />

      {/* Microsoft Logo - Bottom Center */}
      <img
        src="https://res.public.onecdn.static.microsoft/assets/framework/microsoft.svg"
        alt="Microsoft"
        className={styles.microsoftLogo}
      />
    </div>
  )
}
